// This file is the bridge so that any newly added DOM that needs multiselect hydration can call this file
// This controller is currently exclusively used by newly added entries in n-groups

import { Controller } from "@hotwired/stimulus"
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import Multiselect from '../../../frontend/components/Multiselect.vue'
import PrimeVue from 'primevue/config';

export default class extends Controller {
  connect() {
    console.log('multiselect detected')
    this.app = createApp()
    this.app.component('multiselect', Multiselect)
    this.app.use(PrimeVue, { unstyled: true })
    this.app.mount(this.element)
  }

  disconnect() {
    this.app.unmount()
  }
}
